

import { TagSearchBox } from './tagSearchBox';
import { SelectBox } from './SelectBox';
import { Dropdown } from './components/dropdown/Dropdown';

export { TagSearchBox, SelectBox };

export const UInput = {
    SearchTags: TagSearchBox,
    Select: SelectBox,
    Dropdown: Dropdown,
};


import { TagSearchBox } from './tagSearchBox';
import { SelectBox } from './SelectBox';
import { Dropdown } from './components/dropdown/Dropdown';

export { TagSearchBox, SelectBox };

export const UInput = {
    SearchTags: TagSearchBox,
    Select: SelectBox,
    Dropdown: Dropdown,
};
